<template>
    <div
        class="height-transition"
        :class="{
            'open': open,
            'display-overflow': displayOverflow && !overrideOverflow,
        }"
        :inert="!open"
    >
        <div class="container">
            <slot />
        </div>
    </div>
</template>
<script setup>
import { ref, watch, onMounted, computed } from 'vue';

const props = defineProps({
    open: {
        type: Boolean,
        required: false,
        default: false,
    },
    overrideOverflow: {
        type: Boolean,
        required: false,
        default: false,
    },
    transitionTimeout: {
        type: Number,
        required: false,
        default: 500,
    },
});

const transitionClass = computed(() => `${props.transitionTimeout}ms ease-in-out`);

const displayOverflow = ref(false);

watch(() => props.open, to => {
    if (to === true) {
        setTimeout(() => {
            displayOverflow.value = true;
        }, props.transitionTimeout);
    } else {
        displayOverflow.value = false;
    }
});

onMounted(() => {
    if (props.open) {
        setTimeout(() => {
            displayOverflow.value = true;
        }, props.transitionTimeout);
    } else {
        displayOverflow.value = false;
    }
});
</script>
<style scoped>
.height-transition {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 0fr;
  will-change: grid-template-rows;
  transition: all v-bind(transitionClass);
}
.height-transition > .container {
  overflow: hidden;
  opacity: 0;
  transition: v-bind(transitionClass);
}
.height-transition.display-overflow > .container {
  max-width: 100%;
  overflow-y: visible;
}
.height-transition.open {
  grid-template-rows: 1fr;
}
.height-transition.open > .container {
  opacity: 1;
}
</style>
